import { AppLayout } from 'components/index';

export function PublicLayout() {
  return <AppLayout />;
}
